import styled from 'styled-components'
import colors from 'globals/colors'

export const ClientMailsWrapper = styled.div`
  flex: 1;
  overflow-y: auto;

  .ant-table .ant-table-tbody .ant-table-row td.ant-table-cell {
    line-height: 28px;
    padding: 8px 16px;
  }
`

export const MailDatesCell = styled.div`
  & > p {
    margin-bottom: 0;
  }
`

export const MailRef = styled.span`
  line-height: 22px;
  font-weight: bold;
  color: ${colors.darkGrey};
`
